import { render, staticRenderFns } from "./PageAlerts.vue?vue&type=template&id=579a60c4&scoped=true&"
import script from "./PageAlerts.vue?vue&type=script&lang=js&"
export * from "./PageAlerts.vue?vue&type=script&lang=js&"
import style0 from "./PageAlerts.vue?vue&type=style&index=0&id=579a60c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a60c4",
  null
  
)

export default component.exports